module.exports = __webpack_public_path__ + "static/media/chatIcon.b2ba210e.svg";